
<section id="crypto-wrapper" class="py-md-5  crypto-wrapper" [ngClass]="{'arabic': lang === 'ar','no-en': langs()}">
  
  <div class="container">
    <div class="row align-items-center justify-content-center">
      <div class="col-lg-3 text-center text-lg-start">
        <img class="img-fluid my-5 pb-3 pb-sm-0 my-lg-0 token-img" src="./assets/images/new/token-img.svg" alt="" />
      </div>
      <div class="col-lg-8">
        <div class="row">
          <h2 class="col-lg-8 fw-semibold mb-3 mb-md-5 font-48 text-center text-blue" [ngClass]="{'text-lg-end': lang === 'ar'}">{{"token-head"|translate}}</h2>
          
        </div>
         <div class="row ">
          <div class="col-md-4 mb-17" *ngFor="let item of items">
            <div class="buy-box text-center" >
              <div class="mb-3 pb-1">
                <svg-icon  src="{{item.icon}}" [svgStyle]="{ 'width.px':50,'height.px':50}"></svg-icon>
              </div>
              <div>
                <h3 class="fw-semibold font-20 mb-2 text-blue">{{item.head | translate}}</h3>
                <p class=" font-16 fw-medium mb-0 text-light px-0 ">{{item.para |  translate}}</p>
             </div>
            </div>
          </div>
          <div class="col-md-4 text-center align-self-center my-5 my-md-0 pt-4 pt-md-0">
            <!-- <img src="./assets/images/new/token-avtar.svg" alt="" class="img-fluid token-avtar-img"> -->
              <div class="lottie-animation mt-10">
                <ng-lottie
               [styles]="styles"
                 [options]="options" 
                 (animationCreated)="onAnimate($event)">
                </ng-lottie>
            </div>
          </div>
        </div>
      </div>
      
    </div>
    <div class="row mt-5 pt-5 d-none d-md-block">
      <div class="col-md-12 d-flex justify-content-center my-lg-5">
        <img src="./assets/images/new/group-icons.svg" alt="" class="imgg img-fluid">
     </div>
   </div>
 
  </div>
 </section>
